module.exports = __webpack_public_path__ + "img/GH-kyujin-design002.d1a5f19f.webp";